import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefourseaterurbaniahireinpune() {



  const cardData =
  {
    keyword: '14 Seater Urbania Hire in Pune',
    heading: 'Amruta Travels: 14 Seater Urbania Hire in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides 14 Seater Urbania Hire in Pune for travelers who seek premium comfort and convenience for group travel. Ideal for corporate transfers, airport pickups, family tours, and wedding events, our 14-seater Urbania vans feature elegant interiors, superior air conditioning, and ample space for both passengers and luggage. Each vehicle is maintained in pristine condition and driven by professional chauffeurs to ensure safety, punctuality, and a smooth journey. Whether you’re traveling within Pune or to outstation destinations like Lonavala, Mahabaleshwar, or Mumbai, Amruta Travels’ 14 Seater Urbania on Hire in Pune promises a luxurious and reliable travel experience every time.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the royal residence of Bajirao I, it reflects the grandeur of Maratha architecture with its massive gates, fountains, and gardens. The evening light and sound show brings history to life. Shaniwar Wada remains a must-visit heritage site that tells the glorious tale of Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a symbol of India’s freedom struggle and a masterpiece of Indo-Islamic architecture. Built in 1892 by Sultan Muhammed Shah Aga Khan III, it served as a prison for Mahatma Gandhi and his wife Kasturba during the Quit India Movement. The museum inside preserves rare photos and personal belongings of Gandhi. It stands today as Pune’s monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the Sahyadri hills, is a historical fortress famous for the valor of Tanaji Malusare. The fort offers breathtaking panoramic views of the surrounding valleys and is a popular trekking destination. Ancient ruins, cannons, and the Tanaji memorial make it a must-see for history lovers. Sinhagad Fort is Pune’s majestic reminder of Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s spiritual heart, attracting devotees from across India. The temple’s beautifully adorned idol of Lord Ganesha is known for its grandeur and divine presence. During Ganesh Chaturthi, the area transforms into a dazzling festival of lights, music, and devotion. It’s a sacred landmark representing Pune’s deep-rooted faith and cultural pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a serene escape in Pune offering panoramic city views and spiritual calm. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. The 108-step climb rewards visitors with peace and stunning sunsets. Parvati Hill combines Pune’s heritage, spirituality, and scenic beauty in one tranquil experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple carved from basalt stone, dedicated to Lord Shiva. The temple’s circular Nandi mandapa and stone pillars showcase ancient Indian craftsmanship. Located in the city center, it offers a quiet retreat from urban hustle. Pataleshwar Temple stands as Pune’s timeless link to its ancient spiritual roots."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s rich cultural heritage. From antique musical instruments to intricate carvings and rare household items, it’s a treasure trove of history. Founded by Dr. D.G. Kelkar, the museum celebrates India’s artistic excellence. It’s one of Pune’s most fascinating destinations for culture enthusiasts."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global meditation center attracting visitors seeking peace and transformation. Surrounded by lush greenery and tranquil gardens, it offers meditation sessions, yoga, and wellness therapies. The ashram’s modern design and spiritual vibe create a unique experience. Osho Ashram is Pune’s international hub for inner healing and mindfulness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular weekend getaway just outside Pune, offering serene lakeside views and breezy weather. It supplies water to the city and provides a scenic backdrop for picnics and evening drives. Visitors enjoy street food stalls and photography near the lake. Khadakwasla is Pune’s peaceful escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s Korakuen Garden, is a beautifully landscaped park in Sinhagad Road. With its flowing streams, manicured lawns, and traditional Japanese design, it offers a tranquil environment for nature lovers. Families and couples stroll along its bridges and pathways. It symbolizes Pune’s connection to global harmony and natural beauty."
  }
],



     "services": [
    {
      "name": "14 Seater Urbania Hire in Pune",
      "description": "14 Seater Urbania Hire in Pune provides reliable and spacious van rentals tailored for groups seeking comfortable travel within the city and nearby areas. Ideal for family outings, corporate trips, and group excursions, these vans offer ample seating and luggage space, ensuring convenience and safety. The service includes professional drivers who are familiar with Pune’s routes, delivering timely and smooth journeys with a focus on customer satisfaction."
    },
    {
      "name": "Force Urbania 14 Seater Pune",
      "description": "Force Urbania 14 Seater Pune specializes in renting out the durable and spacious Force Urbania vans, popular for their reliability and performance. Perfect for group travel, these vans are regularly maintained and equipped with safety features. Experienced drivers ensure a comfortable ride, whether for city travel, corporate events, or leisure trips across Pune and beyond."
    },
    {
      "name": "AC 14 Seater Urbania Pune",
      "description": "AC 14 Seater Urbania Pune offers air-conditioned vans that provide a cool and pleasant travel experience, especially suited to Pune’s warm climate. These vans are perfect for business professionals, tourists, and families who want a premium, comfortable ride. Equipped with modern AC systems and spacious interiors, the service guarantees a smooth, refreshing journey accompanied by courteous drivers."
    },
    {
      "name": "Non AC Urbania Pune",
      "description": "Non AC Urbania Pune offers cost-effective van rentals without air conditioning, ideal for customers looking for affordable yet reliable group transportation. These vans maintain high standards of safety and comfort, making them suitable for short city trips, school outings, or local commutes. The service emphasizes punctuality, vehicle upkeep, and professional driver conduct to ensure a hassle-free experience."
    },
    {
      "name": "Luxury 14 Seater Urbania Pune",
      "description": "Luxury 14 Seater Urbania Pune delivers premium van rental services with upscale interiors, enhanced seating comfort, and additional amenities. These vans are designed for VIP clients, wedding parties, corporate functions, and special occasions where style and elegance are essential. Professional chauffeurs provide attentive and discreet service, ensuring an exclusive and memorable travel experience."
    },
    {
      "name": "14 Seater Urbania Hire Baner",
      "description": "14 Seater Urbania Hire Baner caters specifically to the Baner locality, providing well-maintained vans for group transport needs. Whether for corporate shuttles, family outings, or event transfers, this service offers flexible booking options and reliable vehicles. The professional drivers navigate Baner’s roads efficiently, prioritizing passenger safety and timely service."
    },
    {
      "name": "14 Seater Urbania Hire Hadapsar",
      "description": "14 Seater Urbania Hire Hadapsar offers dependable van rental services for residents and businesses in Hadapsar. These vans are suitable for daily commutes, office transport, and social events, featuring spacious seating and ample storage. Drivers are experienced and courteous, ensuring smooth and safe travel tailored to client schedules."
    },
    {
      "name": "14 Seater Urbania Hire Pimpri",
      "description": "14 Seater Urbania Hire Pimpri provides accessible and affordable group transport solutions for the Pimpri area. Perfect for employee transportation, family trips, and local travel, this service features reliable vans maintained to the highest safety standards. Skilled drivers ensure punctual pickups and comfortable rides throughout Pimpri and its surroundings."
    },
    {
      "name": "14 Seater Urbania Hire Hinjewadi",
      "description": "14 Seater Urbania Hire Hinjewadi is tailored to meet the commuting needs of the IT and corporate hub, offering efficient van rentals for office employees, client visits, and business outings. The service is known for timely pickups, professional drivers, and clean, well-equipped vehicles that ensure a pleasant travel experience despite the area’s busy traffic."
    },
    {
      "name": "Corporate Urbania Hire Pune",
      "description": "Corporate Urbania Hire Pune specializes in professional van rental services designed for businesses requiring reliable employee transport, client visits, and corporate events. Offering flexible rental plans, this service ensures clean vehicles, expert drivers, and punctual service to support the dynamic schedules of corporate clients across Pune."
    },
    {
      "name": "Wedding Urbania Pune",
      "description": "Wedding Urbania Pune offers elegant and well-decorated vans ideal for transporting wedding guests, bridal parties, and family members. With attention to detail, timely service, and courteous chauffeurs, this service adds a touch of sophistication to wedding celebrations, ensuring smooth logistics and comfortable travel on the special day."
    },
    {
      "name": "Family Urbania Trip Pune",
      "description": "Family Urbania Trip Pune caters to family groups looking for spacious and comfortable van rentals for outings, vacations, and celebrations. These vans offer a safe and enjoyable travel environment, with ample seating and luggage space. Professional drivers prioritize family safety and convenience, making every trip relaxed and memorable."
    },
    {
      "name": "Outstation Urbania Pune",
      "description": "Outstation Urbania Pune provides long-distance van rentals for group travel beyond Pune, including tours, business trips, and leisure journeys to nearby cities and tourist destinations. These vans are equipped for comfort during extended trips, featuring spacious interiors, adequate luggage compartments, and experienced drivers familiar with intercity routes to ensure a safe and timely journey."
    },
    {
      "name": "Affordable 14 Seater Urbania Pune",
      "description": "Affordable 14 Seater Urbania Pune delivers budget-friendly van rental options without compromising on quality or safety. This service targets individuals and groups seeking economical transport for daily commutes, social outings, or corporate needs. Transparent pricing, flexible bookings, and dependable vehicles make it a popular choice for cost-conscious customers."
    },
    {
      "name": "Urbania Booking Online Pune",
      "description": "Urbania Booking Online Pune offers a seamless digital platform for reserving 14 seater Urbania vans. Customers benefit from instant booking confirmation, transparent pricing, multiple payment methods, and easy scheduling. The platform supports route customization and 24/7 customer service, ensuring a convenient and efficient booking experience across Pune."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune provides quick access to 14 seater Urbania vans located throughout Pune for immediate or scheduled travel. This service focuses on localized availability, ensuring prompt pickups and flexible rental durations. Professional drivers and well-maintained vehicles ensure that customers enjoy safe, comfortable, and timely transportation."
    },
    {
      "name": "Force Urbania Rental Pune",
      "description": "Force Urbania Rental Pune features rentals of the dependable Force Urbania vans, known for their robust build and passenger comfort. This service caters to groups needing spacious and reliable transport with ample seating and luggage capacity. Regularly serviced vehicles and professional drivers make this an excellent choice for both city travel and longer journeys."
    },
    {
      "name": "Best Urbania Service Pune",
      "description": "Best Urbania Service Pune is committed to delivering top-quality van rental services characterized by well-maintained vehicles, courteous drivers, and excellent customer support. This service prioritizes safety, comfort, and punctuality, making it the preferred choice for families, corporate clients, and event organizers seeking dependable and efficient transportation in Pune."
    }
  ],
  "tableData": [
    ["14 Seater Urbania Hire in Pune", "Force Urbania 14 Seater Pune"],
    ["AC 14 Seater Urbania Pune", "Non AC Urbania Pune"],
    ["Luxury 14 Seater Urbania Pune", "14 Seater Urbania Hire Baner"],
    ["14 Seater Urbania Hire Hadapsar", "14 Seater Urbania Hire Pimpri"],
    ["14 Seater Urbania Hire Hinjewadi", "Corporate Urbania Hire Pune"],
    ["Wedding Urbania Pune", "Family Urbania Trip Pune"],
    ["Outstation Urbania Pune", "Affordable 14 Seater Urbania Pune"],
    ["Urbania Booking Online Pune", "Urbania Hire near Me Pune"],
    ["Force Urbania Rental Pune", "Best Urbania Service Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "14 Seater Urbania Hire in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers reliable 14 seater Urbania hire services in Pune, perfect for comfortable group travel and city tours."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our 14 seater Urbania vans are regularly serviced and thoroughly sanitized to ensure your safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy upfront rental rates with no hidden charges, inclusive of all taxes and fees."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure a safe, punctual, and pleasant journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and queries."
  },
  {
    "WhyChooseheading": "Easy Booking Process",
    "WhyChoosedescription": "Book your 14 seater Urbania hassle-free online or by phone, with prompt vehicle delivery across Pune."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Guaranteed",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is committed to providing efficient, comfortable, and reliable group travel services."
  }
]




























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd provide 14 seater Urbania hire services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd offers reliable 14 seater Urbania hire services in Pune, perfect for group travel and events.',
  },
  {
    question: 'How can I book a 14 seater Urbania for hire in Pune with Amruta Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What amenities are included in the 14 seater Urbania vehicles in Pune?',
    answer: 'Our 14 seater Urbania vehicles come with comfortable seating, air conditioning, and essential safety features for a smooth ride.',
  },
  {
    question: 'Are the drivers trained and experienced for 14 seater Urbania hires in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and experienced in handling 14 seater Urbania vehicles.',
  },
  {
    question: 'Can 14 seater Urbania vehicles be hired for weddings and corporate events in Pune?',
    answer: 'Yes, our 14 seater Urbania vehicles are ideal for weddings, corporate outings, airport transfers, and special occasions in Pune.',
  },
  {
    question: 'Is the 14 seater Urbania hire service available 24x7 in Pune?',
    answer: 'Yes, Amruta Travels offers round-the-clock 14 seater Urbania hire services in Pune to fit your schedule.',
  },
  {
    question: 'What hygiene and safety protocols are followed for 14 seater Urbania hires?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures to ensure passenger safety.',
  },
  {
    question: 'What payment methods are accepted for 14 seater Urbania hire in Pune?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for hassle-free payments.',
  },
  {
    question: 'Is customer support available throughout the 14 seater Urbania hire in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you at any time during your rental period in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Joshi',
    feedback: 'The 14 seater Urbania hired from Amruta Travels Pune was spacious and comfortable. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Excellent service for our group trip in Pune. The 14 seater Urbania was clean, well-maintained, and the booking was easy.',
    rating: 5,
  },
];



























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14 Seater Urbania Hire in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/3.jpg",
  "description": "Book a 14 Seater Urbania Hire in Pune with Amruta Travels Pvt. Ltd. for comfortable, reliable, and affordable group travel. Choose from AC, Non-AC, and Luxury Force Urbania options for corporate, wedding, family, and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/14-seater-urbania-hire-in-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>14 Seater Urbania Hire in Pune | Force Urbania AC & Luxury Van | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 14 Seater Urbania Hire in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Force Urbania vans for corporate travel, weddings, family trips, and outstation journeys at the best prices."
  />
  <meta
    name="keywords"
    content="14 Seater Urbania Hire in Pune, Force Urbania 14 Seater Pune, AC 14 Seater Urbania Pune, Non AC Urbania Pune, Luxury 14 Seater Urbania Pune, 14 Seater Urbania Hire Baner, 14 Seater Urbania Hire Hadapsar, 14 Seater Urbania Hire Pimpri, 14 Seater Urbania Hire Hinjewadi, Corporate Urbania Hire Pune, Wedding Urbania Pune, Family Urbania Trip Pune, Outstation Urbania Pune, Affordable 14 Seater Urbania Pune, Urbania Booking Online Pune, Urbania Hire near Me Pune, Force Urbania Rental Pune, Best Urbania Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onefourseaterurbaniahireinpune;